import { createContext, useContext } from "react";

export type SentryContextValue = {
  dev: {
    /**
     * Editor will be used to open the source code.
     *
     * @default "vscode"
     */
    editor: "vscode" | "antigravity" | "cursor";

    /**
     * Examples:
     * - WSL on Windows: `""`
     * - Cursor on Mac: `"file/Users/.../apps/web"`
     *
     * @default ""
     */
    rootPath: string;
  };

  config: {
    /**
     * Log in to `https://newsentry.inqool.cz/` and create a new project.
     * Then copy the DSN and paste it here. Ideally put it into the `.env` file.
     */
    dsn: string;
  };

  /**
   * Example:
   * - `process.env.NODE_ENV === "production" ? "Production" : "Development"`
   */
  mode: "Development" | "Production";

  /**
   * @default "Development"
   */
  environment?: string;

  /**
   * Enables the feedback form and screenshot capture for all error boundaries.
   *
   * @default false
   */
  enableFeedback: boolean;
};

export const SentryContext = createContext<SentryContextValue | null>(null);

export function useSentryContext() {
  const context = useContext(SentryContext);

  if (!context) {
    console.log("useSentryContext must be used within a SentryProvider");

    return null;
  }

  return context;
}
